import React, { FC, memo, PropsWithChildren } from "react";
import useProfilePreview from "./index.hooks";
import { IMerchant } from "../../models/Merchant";
import { AppButton, AppPaper, CreateMerchantBannerDialog } from "../index";
import EventBannerPlaceholder from "../../assets/images/event-image-placeholder.jpeg";
import { Divider, Fab, IconButton, Typography } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

type ProfilePreviewProps = {
  merchant: IMerchant;
};

const ProfilePreview: FC<PropsWithChildren<ProfilePreviewProps>> = (props) => {
  const {
    styles,
    classes,
    atomicStyles,
    handleImageDialogOpen,
    t,
  } = useProfilePreview();

  return (
    <AppPaper className={styles.paper}>
      <CreateMerchantBannerDialog />
      <img
        className={styles.imgPreview}
        src={
          props.merchant.imageUri
            ? props.merchant.imageUri
            : EventBannerPlaceholder
        }
        alt="banner"
      />
      <Fab
        className={styles.buttonAdd}
        color="primary"
        onClick={handleImageDialogOpen}
      >
        <EditIcon />
      </Fab>
      <div className={styles.divContent}>
        <Typography className={styles.titlePreview}>
          {props.merchant.name.trim() === ""
            ? t("Titolo")
            : props.merchant.name}
        </Typography>
      </div>
    </AppPaper>
  );
};

export default memo(ProfilePreview);
